import { errorMessage } from "@streamoid/errors";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { ScreenType, NavigationState } from "./types/navigation";
import { HeroSection } from "./HeroSection";
import { EmailEntryScreen } from "./EmailEntryScreen";
import { OtpVerificationScreen } from "./OtpVerificationScreen";
// import img98 from "figma:asset/35f15a664f2ccddff9bb6ee1fca7adc35be4677b.png";
import "/styles/globals.css";
import "./styles.css";

import { generateOTP, getProfile, validateOtp } from "../../utils/account";
import Cookies from "js-cookie";
import { EMAIL_REGEX, notify } from "../../utils/utils";
// Background Component
const Background: React.FC = () => {
  return (
    <div className="bg-container">
      <div
        className="bg-image"
        // style={{ backgroundImage: `url('${img98}')` }}
      />
    </div>
  );
};

// Main Layout Component
const MainLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <div className="main-layout">
      <HeroSection />
      {children}
    </div>
  );
};

// Main App Component
export default function Login() {
  const navigate = useNavigate();
  const { search } = useLocation();
  const [navigationState, setNavigationState] = useState<NavigationState>({
    currentScreen: ScreenType.EMAIL_ENTRY,
    email: "",
    otpCode: "",
    hasError: false,
    errorText: "",
  });

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const result: any = await getProfile();

        const isLoggedIn =
          result && result.data && result.data._id ? true : false;

        if (isLoggedIn) {
          navigate("/workspace");
        }
      } catch (err) {
        const queryParams = new URLSearchParams(search);

        // To convert all params to an object:
        const allParams = Object.fromEntries(queryParams.entries());

        if (Object.keys(allParams).length) {
          navigate("/login" + search);
        } else {
          navigate("/login");
        }
      }
    };

    fetchProfile();
  }, []);

  // Handle email input change
  const handleEmailChange = (email: string) => {
    setNavigationState((prev) => ({
      ...prev,
      email,
      hasError: false,
      errorText: "",
    }));
  };

  const handleContinue = () => {
    console.log("@handleContinue");

    if (!navigationState.email.trim()) {
      setNavigationState((prev) => ({
        ...prev,
        hasError: true,
        errorText: "Email can not be empty.",
      }));
      return;
    }

    if (!EMAIL_REGEX.test(navigationState.email.trim())) {
      setNavigationState((prev) => ({
        ...prev,
        hasError: true,
        errorText: "Please enter a valid email address.",
      }));
      return;
    }
    if (navigationState.email.trim()) {
      generateOTP(navigationState.email.trim())
        .then((res) => {
          setNavigationState((prev) => ({
            ...prev,
            currentScreen: ScreenType.OTP_VERIFICATION,
            otpCode: "",
            hasError: false,
          }));
        })
        .catch((err) => {
          console.log(err);
          const message = errorMessage(err);
          setNavigationState((prev) => ({ ...prev, hasError: true, errorText: message }));
          notify(message, "error");
        });
    }
  };

  // Handle OTP code change
  const handleOtpChange = (otpCode: string) => {
    setNavigationState((prev) => ({
      ...prev,
      otpCode,
      hasError: false,
    }));
  };

  const handleValidateOtp = (otp: string) => {
    const referralCode = localStorage.getItem("referral_code");

    validateOtp(navigationState.email, otp, referralCode)
      .then((otpResponse: any) => {
        console.log("otpResponse", otpResponse);

        if (window && window.redirectUrl) {
          window.location.href = window.redirectUrl;
        }
        if (otpResponse.status.code === -1) {
          // updateErr(otpResponse.status.message);
          setNavigationState((prev) => ({
            ...prev,
            hasError: true,
          }));
        } else {
          if (otpResponse.data && otpResponse.data.firstTimeLogin) {
            setNavigationState((prev) => ({
              ...prev,
              currentScreen: ScreenType.SETUP_ACCOUNT,
              hasError: false,
            }));
          } else {
            navigate("/home");
          }

          if (otpResponse.data.name.trim()) {
            const redirectTo = localStorage.getItem("redirectTo");
            const referralCode = localStorage.getItem("referral_code");
            // if (referralCode) {
            //   localStorage.removeItem("referral_code");
            // }
            // if (redirectTo) {
            //   localStorage.removeItem("redirectTo");
            //   // history.push(redirectTo);
            // } else {
            // getWorkspaces()
            //   .then((res) => {
            //     if (res.data && res.data[0]) {
            //       const userData = otpResponse.data;
            //       let lastActiveUrl = "";
            //       if (userData.lastActiveWorkspaceId) {
            //         lastActiveUrl = userData.lastActiveWorkspaceId;
            //       }
            //       if (userData.lastActiveStoreId) {
            //         lastActiveUrl += "/stores/" + userData.lastActiveStoreId;
            //       }
            //       const lastActiveWorkspace = res.data.find(
            //         (workspace) =>
            //           workspace._id == userData.lastActiveWorkspaceId
            //       );
            //       history.push(
            //         "/dashboard/" +
            //           (lastActiveWorkspace
            //             ? lastActiveUrl.length
            //               ? lastActiveUrl
            //               : lastActiveWorkspace._id
            //             : res.data[0]._id)
            //       );
            //     } else {
            //       history.push("/dashboard");
            //     }
            //   })
            //   .catch((err) => {
            //     console.log(err);
            //   });
            // }
          } else {
            // props.profile();
          }
        }
      })
      .catch((err: any) => {
        console.log(err);
        setNavigationState((prev) => ({
          ...prev,
          hasError: true,
        }));
        // const parsedError = parseJson(err);
        // updateErr(
        //   (parsedError && parsedError.status && parsedError.status.message) ||
        //     parsedError
        // );
      });
  };

  // Handle OTP verification
  const handleVerify = () => {
    console.log("handleVerify");
    if (navigationState.otpCode.length !== 6) {
      setNavigationState((prev) => ({
        ...prev,
        hasError: true,
      }));
    } else {
      // Process OTP verification
      console.log("OTP verified:", navigationState.otpCode);
      // Here you would typically make an API call to verify the OTP
      // For demo purposes, we'll simulate an error for any code other than "123456"
      handleValidateOtp(navigationState.otpCode);
    }
  };

  // Handle resend - go back to email entry
  const handleResend = () => {
    setNavigationState((prev) => ({
      ...prev,
      currentScreen: ScreenType.EMAIL_ENTRY,
      otpCode: "",
      hasError: false,
    }));
  };

  // Render current screen
  const renderCurrentScreen = () => {
    try {
      switch (navigationState.currentScreen) {
        case ScreenType.EMAIL_ENTRY:
          return (
            <EmailEntryScreen
              email={navigationState.email}
              onEmailChange={handleEmailChange}
              onContinue={handleContinue}
              hasError={navigationState.hasError}
              errorText={navigationState.errorText}
              isSetupScreen={false}
            />
          );
        case ScreenType.OTP_VERIFICATION:
          return (
            <OtpVerificationScreen
              email={navigationState.email}
              otpCode={navigationState.otpCode}
              hasError={navigationState.hasError}
              onOtpChange={handleOtpChange}
              onVerify={handleVerify}
              onResend={handleResend}
            />
          );

        case ScreenType.SETUP_ACCOUNT:
          return (
            <EmailEntryScreen
              email={navigationState.email}
              onEmailChange={handleEmailChange}
              onContinue={handleContinue}
              hasError={navigationState.hasError}
              isSetupScreen={true}
            />
          );
        default:
          return (
            <div style={{ color: "red", padding: "20px" }}>
              Unknown screen type: {navigationState.currentScreen}
            </div>
          );
      }
    } catch (error) {
      console.error("Error rendering screen:", error);
      return (
        <div style={{ color: "red", padding: "20px" }}>
          Error rendering screen:{" "}
          {error instanceof Error ? error.message : "Unknown error"}
        </div>
      );
    }
  };

  return (
    <div className="app-root">
      <Background />
      <MainLayout>{renderCurrentScreen()}</MainLayout>
    </div>
  );
}
